import fc from '../firebaseConfig'
import firebase from 'firebase/app'
import axios from 'axios'

export function uploadToCurrentUserCompanyBucket(img, companyID, relativeRef, onProgress) {
  const userID = fc.auth.currentUser.uid
  const ext = img.name.split('.').pop()
  const ref = `Users/${userID}/Companies/${companyID}/${relativeRef}/${Date.now()}.${ext}`
  return uploadToBucket(img, ref, onProgress)
}

export function uploadToBucket(img, ref, onProgress) {
  return new Promise((resolve, reject) => {
    console.log('[uploadToBucket] ref => ', ref)
    const storageRef = firebase.storage().ref(ref);
    const uploadTask = storageRef.put(img);

    uploadTask.on('state_changed',
      // on progress
      snapshot => {
        let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        if (onProgress) {
          onProgress(percentage)
        }
      },
      // on error
      err => {
        reject(err)
      },
      // on result
      () => {
        uploadTask.then((snapshot) => {
          const gsPath = 'gs://' + snapshot.ref.bucket + "/" + snapshot.ref.fullPath
          snapshot.ref.getDownloadURL().then(() => {
            axios.get(fc.getImageUrl + gsPath)
              .then(function (response) {
                if (response && response.data && response.data.image_url) {
                  const result = {
                    imageUrl: response.data.image_url,
                    storagePath: gsPath,
                  }
                  resolve(result)
                } else {
                  reject(new Error('Failed to retrieve image url'))
                }
              })
              .catch(err => {
                reject(err)
              })
          });
        });
      });
  })
}

export default {
  uploadToCurrentUserCompanyBucket,
  uploadToBucket,
}